import { createFileRoute } from '@tanstack/react-router'
import { LocationSectionPage } from '@/features/setup/location-section-page'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/setup/location')({
  component: LocationSectionRoute,
})

function LocationSectionRoute() {
  const { workspaceSlug } = Route.useParams()

  return <LocationSectionPage workspaceSlug={workspaceSlug} />
}
